/* eslint-disable react/prop-types */
import { Col, DatePicker, Form, Row, TimePicker } from 'antd'
import moment from 'moment'

const defaultProps = {
  disableTime: false,
  endDate: moment().endOf('month'),
  endHour: moment('23:59:59', 'HH:mm:ss'),
  startDate: moment().startOf('month'),
  startHour: moment('00:00:00', 'HH:mm:ss')
}

const EAReportDateTimeFilter = ({
  disableTime,
  endDate,
  endHour,
  startDate,
  startHour
}) => (
  <Row gutter={16}>
    <Col xs={24} md={12}>
      <Form.Item
        initialValue={startDate}
        label="Data inicial"
        name="startDate"
        rules={[{ required: true }]}
      >
        <DatePicker format="DD/MM/yyyy" style={{ width: '100%' }} />
      </Form.Item>
    </Col>

    <Col xs={24} md={12}>
      <Form.Item
        initialValue={endDate}
        label="Data final"
        name="endDate"
        rules={[{ required: true }]}
      >
        <DatePicker format="DD/MM/yyyy" style={{ width: '100%' }} />
      </Form.Item>
    </Col>

    {disableTime ? null : (
      <>
        <Col xs={24} md={12}>
          <Form.Item
            initialValue={startHour}
            label="Hora inicial"
            name="startHour"
            rules={[{ required: true }]}
          >
            <TimePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            initialValue={endHour}
            label="Hora final"
            name="endHour"
            rules={[{ required: true }]}
          >
            <TimePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </>
    )}
  </Row>
)

EAReportDateTimeFilter.defaultProps = defaultProps

export default EAReportDateTimeFilter
